<template>
  <div
    v-show="show"
    class="notification popup"
    :class="styleClass"
  >
    <button
      type="button"
      class="delete"
      @click="(e) => {
        e.stopPropagation()
        show = false
      }"
      aria-label="Close notification"
    />
    {{ store.popup.text }}
  </div>
</template>

<script
  lang="ts"
  setup
>
/** A Notification toast that shows a notification that gets set from Vuex */
import { computed, ref, watch } from "vue"
import { useNotificationsStore } from "./store"

const STYLES = {
  'success': 'is-success',
  'warn': 'is-warning',
  'error': 'is-danger'
}

const store = useNotificationsStore()

const show = ref(false)

watch(() => store.popup, (newValue) => {
  if (newValue.duration && newValue.duration <= 0) {
    show.value = false
  } else {
    show.value = true
    setTimeout(() => {
      show.value = false
    }, store.popup.duration)
  }
})

const styleClass = computed(() => {
  if (store.popup.style === null) {
    return ""
  } else {
    return STYLES[store.popup.style]
  }
})
</script>

<style scoped>
.popup {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
}
</style>